<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import { barChart } from "../../views/datafake/data-produtos-overview";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "Detalhes Produto",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader },
  data() {
    return {
      produtoData: {

      },
      idData: 0,
      updating: true,
      barChart: barChart,
      title: "Detalhes Produto",
      items: [
        {
          text: "Produtos",
          href: "/produtos/list"
        },
        {
          text: "Detalhes Produto",
          active: true
        }
      ]
    };
  },
  mounted() {
    console.log('mounted produto-detalhe_0')

    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      api.get(`${getBaseUrl()}api/produto`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.produtoData = res.data[0]


        let imgTrat = this.produtoData.imgs.split(',')
        this.produtoData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`


        this.idData = this.produtoData.id
        this.title = `Detalhes Produto (${this.produtoData.id}) ${this.produtoData.descricao}`
        this.updating = false
      });
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating" >
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <img :src="produtoData.img1" alt class="avatar-sm me-4" />

              <div class="flex-grow-1 overflow-hidden">
                <h5 class="text-truncate font-size-15">{{ produtoData.descricao }}</h5>
                <p class="text-muted">Unidade: UND</p>
              </div>
            </div>

            <h5 class="font-size-15 mt-4">Grupo Testes 001</h5>

            <p
                class="text-muted"
            >Descrição auxiliar produto (observações)</p>

            <div class="text-muted mt-4">
              <p>
                <i class="mdi mdi-chevron-right text-primary me-1"></i> Peso Bruto: 0 kg
              </p>
              <p>
                <i class="mdi mdi-chevron-right text-primary me-1"></i> Peso Líquido: 0 kg
              </p>
              <p>
                <i class="mdi mdi-chevron-right text-primary me-1"></i> Fabricante Testes 0088
              </p>
            </div>

            <div class="row task-dates">
              <div class="col-sm-4 col-6">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-calendar me-1 text-primary"></i> Último Orçamento
                  </h5>
                  <p class="text-muted mb-0">01 Abr, 2023</p>
                </div>
              </div>

              <div class="col-sm-4 col-6">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-calendar-check me-1 text-primary"></i> Último Pedido
                  </h5>
                  <p class="text-muted mb-0">01 Abr, 2023</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Últimos Pedidos</h4>

            <div class="table-responsive">
              <table class="table table-nowrap align-middle">
                <tbody>

                <tr>
                  <td style="width: 50px;">
                    <div class="avatar-xs">
                        <span
                            class="avatar-title rounded-circle bg-soft-primary text-white font-size-16"
                        >ES</span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 m-0">
                      <a href class="text-dark">Cliente Testes 0002</a>
                      <br>
                      <span class="text-truncate font-size-12"> 19/02/2023 </span>
                    </h5>
                  </td>
                  <td>
                    <div>
                      <a
                          href="javascript: void(0);"
                          class="badge bg-primary bg-soft text-primary font-size-11">
                        #005877
                      </a>
                      <br>
                      <span class="text-truncate font-size-12"> R$ 354,55</span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td style="width: 50px;">
                    <div class="avatar-xs">
                        <span
                            class="avatar-title rounded-circle bg-soft-primary text-white font-size-16"
                        >ES</span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 m-0">
                      <a href class="text-dark">Cliente Testes 0098</a>
                      <br>
                      <span class="text-truncate font-size-12"> 18/02/2023 </span>
                    </h5>
                  </td>
                  <td>
                    <div>
                      <a
                          href="javascript: void(0);"
                          class="badge bg-primary bg-soft text-primary font-size-11">
                        #005877
                      </a>
                      <br>
                      <span class="text-truncate font-size-12"> R$ 1.000,99</span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td style="width: 50px;">
                    <div class="avatar-xs">
                        <span
                            class="avatar-title rounded-circle bg-soft-primary text-white font-size-16"
                        >MG</span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 m-0">
                      <a href class="text-dark">Cliente Testes 0007</a>
                      <br>
                      <span class="text-truncate font-size-12"> 15/02/2023 </span>
                    </h5>
                  </td>
                  <td>
                    <div>
                      <a
                          href="javascript: void(0);"
                          class="badge bg-primary bg-soft text-primary font-size-11">
                        #005877
                      </a>
                      <br>
                      <span class="text-truncate font-size-12"> R$ 877,04</span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td style="width: 50px;">
                    <div class="avatar-xs">
                        <span
                            class="avatar-title rounded-circle bg-soft-primary text-white font-size-16"
                        >MG</span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 m-0">
                      <a href class="text-dark">Cliente Testes 00997</a>
                      <br>
                      <span class="text-truncate font-size-12"> 07/02/2023 </span>
                    </h5>
                  </td>
                  <td>
                    <div>
                      <a
                          href="javascript: void(0);"
                          class="badge bg-primary bg-soft text-primary font-size-11">
                        #005877
                      </a>
                      <br>
                      <span class="text-truncate font-size-12"> R$ 10.888,11</span>
                    </div>
                  </td>
                </tr>





                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row" v-if="!updating">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">ùltimos Dias</h4>

            <div id="overview-chart" class="apex-charts" dir="ltr"></div>
            <apexchart
                class="apex-charts"
                type="bar"
                height="280"
                :series="barChart.series"
                :options="barChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Material de Apoio</h4>
            <div class="table-responsive">
              <table class="table table-nowrap table-centered table-hover mb-0 align-middle">
                <tbody>
                <tr>
                  <td style="width: 45px;">
                    <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">
                      <a href="javascript: void(0);" class="text-dark">Imagens produto</a>
                    </h5>
                    <small>Size : 3.25 MB</small>
                  </td>
                  <td>
                    <div class="text-center">
                      <a href="javascript: void(0);" class="text-dark">
                        <i class="bx bx-download h3 m-0"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">
                      <a href="javascript: void(0);" class="text-dark">Campanha Institucional</a>
                    </h5>
                    <small>Size : 3.15 MB</small>
                  </td>
                  <td>
                    <div class="text-center">
                      <a href="javascript: void(0);" class="text-dark">
                        <i class="bx bx-download h3 m-0"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">
                      <a href="javascript: void(0);" class="text-dark">Vídeo de divulgação</a>
                    </h5>
                    <small>Size : 2.02 MB</small>
                  </td>
                  <td>
                    <div class="text-center">
                      <a href="javascript: void(0);" class="text-dark">
                        <i class="bx bx-download h3 m-0"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14">
                      <a href="javascript: void(0);" class="text-dark">Fotos de produto MKT</a>
                    </h5>
                    <small>Size : 2.25 MB</small>
                  </td>
                  <td>
                    <div class="text-center">
                      <a href="javascript: void(0);" class="text-dark">
                        <i class="bx bx-download h3 m-0"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Tabelas de Preços</h4>

            <div class="d-flex mb-4">
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">001 - Atacado</h5>
                <p class="text-muted mb-1">01/01/2023 a 01/01/2029</p>
              </div>
              <div class="ms-3">
                <a href class="text-primary">R$ 354,00</a>
              </div>
            </div>

            <div class="d-flex mb-4">
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">002 - Varejo</h5>
                <p class="text-muted mb-1">01/01/2023 a 01/01/2029</p>
              </div>
              <div class="ms-3">
                <a href class="text-primary">R$ 399,00</a>
              </div>
            </div>


            <div class="d-flex mb-4">
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">003 - Cliente Ouro</h5>
                <p class="text-muted mb-1">01/01/2023 a 01/01/2029</p>
              </div>
              <div class="ms-3">
                <a href class="text-primary">R$ 311,00</a>
              </div>
            </div>

            <div class="d-flex mb-4">
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">004 - Tabela Testes</h5>
                <p class="text-muted mb-1">01/01/2023 a 01/01/2029</p>
              </div>
              <div class="ms-3">
                <a href class="text-primary">R$ 999,00</a>
              </div>
            </div>





            <div class="text-center mt-4 pt-2">
              <a href="javascript: void(0);" class="btn btn-primary btn-sm">Mais detalhes</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>
